export default __webpack_public_path__ + "static/media/2186.733ccffd.png";